export default "__VITE_ASSET__YAXKcuFP__"